import script from "./ViewExpose.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewExpose.vue?vue&type=script&setup=true&lang=js"

import "./ViewExpose.vue?vue&type=style&index=0&id=5166a699&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5166a699"]])

export default __exports__